import { render, staticRenderFns } from "./myabonements.vue?vue&type=template&id=45246feb&scoped=true&"
import script from "./myabonements.vue?vue&type=script&lang=js&"
export * from "./myabonements.vue?vue&type=script&lang=js&"
import style0 from "./myabonements.vue?vue&type=style&index=0&id=45246feb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45246feb",
  null
  
)

export default component.exports